import { useEffect, useRef, useState } from "react";
import "./App.css";
import { MdEdit } from "react-icons/md";

function UserPage() {
  const [data, setData] = useState([]);
  const [selectedForEditUser, setSelectedForEditUser] = useState(false);
  const [selectedForAddUser, setSelectedForAddUser] = useState(false);
  const [selectedForAccess, setSelectedForAccess] = useState(false);
  const [isOpenNewModal, setIsOpenNewModal] = useState(false);
  const [editedUser, setEditedUser] = useState({});
  const [addUser, setAddUser] = useState({});
  const [accessUser, setAccesUser] = useState({});
  const [accessListOfUser, setAccesListOfUser] = useState([]);
  const [roles, setRoles] = useState([]);
  const [deps, setDeps] = useState([]);
  const [isNeedReload, setIsNeedReload] = useState(true);

  const [selectedDepValue, setSelectedDepValue] = useState("");
  const [selectedRoleValue, setSelectedRoleValue] = useState("");
  const [depsForAdd, setDepsForAdd] = useState([]);

  const modalRef = useRef(null);
  useEffect(() => {
    if (isNeedReload) {
      setIsNeedReload(false);
      getUsersList();
      console.log('reload');
    }
  }, [isNeedReload]);

  async function getUsersList() {
    const allUsers = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/users/getAllUsers`
    );
    const result = await allUsers.json();
    setData(result);
    const allDeps = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/users/getAllDepartments`
    );
    const allRoles = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/users/getAllRoles`
    );
    const depsResult = await allDeps.json();
    const roleResult = await allRoles.json();

    setDeps(depsResult);
    setRoles(roleResult);
  }
  const handleEditUser = (item) => {
    console.log("isadmin = " + item.isadmin);
    setSelectedForEditUser(true);
    setEditedUser(item);
  };
  const handeleAddUser = () => {
    setAddUser({});
    setSelectedForAddUser(true);
  };
  const handeleOpenUserAccessEdit = async (item) => {
    setSelectedForAccess(true);
    setAccesUser(item);
    const allUsers = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/users/getRolesByUser?userId=${item.id}`
    );
    const result = await allUsers.json();
    setAccesListOfUser(result);
  };

  const handleOnCancel = () => {
    setSelectedForEditUser(false);
    setSelectedForAddUser(false);
    setEditedUser({});
    setAddUser({});
    setSelectedForAccess(false);
    setAccesUser({});
    setAccesUser({});
    setSelectedDepValue("");
    setSelectedRoleValue("");
    setIsOpenNewModal(false);
  };
  const handleInputChange = (e) => {
    
    const { name, value } = e.target;
    console.log([name]);
    setEditedUser({ ...editedUser, [name]: value });
  };
  const handleInputAddChange = (e) => {
    const { name, value } = e.target;
    console.log([name]);
    setAddUser({ ...addUser, [name]: value });
    //setAddUser({ ...addUser, 'enabled': 1 });
  };
  const handleEditSave = () => {
    console.log("editedUser.isadmin = " + editedUser.isadmin);
    const sendData = {
      userId: editedUser.id,
      password: editedUser.password,
      fullname: editedUser.fullname,
      enabled: editedUser.enabled,
      isadmin: editedUser.isadmin,
    };
    const saveUserApi = `${process.env.REACT_APP_BASE_URL}/api/users/updateUser`;
    fetch(saveUserApi, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(sendData),
    })
      .then((response) => {
        console.log(response);
        setIsNeedReload(true);
      })
      .catch((error) => {
        console.error("Ошибка обновления позиции ", error);
      });
    
    setSelectedForEditUser(false);
  };
  const handleAddSave = () => {
    console.log("addUser.isadmin = " + addUser.isadmin);
    if (!addUser.isadmin) {
      addUser.isadmin = 0;
    }
    if (!addUser.enabled) {
      addUser.enabled = 1;
    }
    const saveUserApi = `${process.env.REACT_APP_BASE_URL}/api/users/addUser`;
    fetch(saveUserApi, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(addUser),
    })
      .then((response) => {
        response.json().then(async response => {
          console.log(response);
          const item = {id: response.id, fullname: response.fullname};
          handeleOpenUserAccessEdit(item);
          setIsNeedReload(true);
        });
      })
      .catch((error) => {
        console.error("Ошибка обновления позиции ", error);
      });
      setSelectedForAddUser(false);
  };
  const handeleWrapClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      handleOnCancel();
    }
  };

  // Handle USer role update
  const openNewModal = () => {
    setIsOpenNewModal(true);
    const filteredDepartments = deps.filter(
      (dep) => !accessListOfUser.find((user) => user.dep_id === dep.id)
    );
    setDepsForAdd(filteredDepartments);
    console.log(roles[0].id);
    setSelectedDepValue(filteredDepartments[0].id.toString());
    setSelectedRoleValue(roles[0].id.toString());
  };
  const handelDeleteRole = (item) => {
    const deleteInfo = {
      user_id: item.user_id,
      dep_id: item.dep_id,
      role: item.role_id,
    };
    const body = {
      id: item.id,
    };
    const saveUserApi = `${process.env.REACT_APP_BASE_URL}/api/users/unSetRoleById`;
    fetch(saveUserApi, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((response) => {
        newRoles(item);
      })
      .catch((error) => {
        console.error("Ошибка обновления позиции ", error);
      });
  };

  const newRoles = async (item) => {
    const allUsers = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/users/getRolesByUser?userId=${item.user_id}`
    );
    const result = await allUsers.json();
    setAccesListOfUser(result);
  };
  const handelChangeSelectRole = (event) => {
    setSelectedRoleValue(event.target.value);
  };

  const handelChangeSelectDep = (event) => {
    setSelectedDepValue(event.target.value);
    console.log(selectedRoleValue);
  };

  const handeleAddRole = (event) => {
    const add__user = {
      user_id: accessUser.id,
      dep_id: selectedDepValue,
      role_id: selectedRoleValue,
    };
    console.log("accessUser.id " + accessUser.id);
    const saveUserApi = `${process.env.REACT_APP_BASE_URL}/api/users/setRole`;
    fetch(saveUserApi, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(add__user),
    })
      .then((response) => {
        console.log(response);
        handeleOpenUserAccessEdit(accessUser);
        handleOnCloseRole();
      })
      .catch((error) => {
        console.error("Ошибка обновления позиции ", error);
      });
  };

  const handleOnCloseRole = () => {
    setSelectedDepValue("");
    setSelectedRoleValue("");
    setIsOpenNewModal(false);
  };

  return (
    <>
      <div className="admin_page">
        <div className="add__buttons" onClick={handeleAddUser}>
          <span>Добавить</span>
        </div>
        <table className="users__table">
          <thead>
            <tr>
              <th>ID</th>
              <th>ФИО</th>
              <th>Логин</th>
              <th>Администратор</th>
              <th>Права</th>
              <th>Активность</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>{item.id}</td>
                <td>{item.fullname}</td>
                <td>{item.login}</td>
                <td>{item.isadmin === 1 ? "Да" : "Нет"}</td>
                <td className="access__of_user">
                  <span onClick={() => handeleOpenUserAccessEdit(item)}>
                    Права пользователя
                  </span>
                </td>
                <td>{item.enabled === 1 ? "Активен" : "Неактивен"}</td>
                <td className="edit__user" onClick={() => handleEditUser(item)}>
                  <MdEdit />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {selectedForEditUser && (
        <div className="edit_user_wrap" onClick={handeleWrapClick}>
          <div ref={modalRef} className="edit_user__modal">
            <span className="close" onClick={handleOnCancel}>
              &times;
            </span>
            <h2>Редактировать пользователя</h2>
            <form>
              <label>ID:</label>
              <input
                type="text"
                name="id"
                value={editedUser.id}
                onChange={handleInputChange}
                disabled
              />
              <label>ФИО:</label>
              <input
                type="text"
                name="fullname"
                value={editedUser.fullname}
                onChange={handleInputChange}
              />
              <label>Логин:</label>
              <input
                type="text"
                name="login"
                value={editedUser.login}
                onChange={handleInputChange}
              />
              <label>Пароль:</label>
              <input
                type="password"
                name="password"
                value={editedUser.password}
                onChange={handleInputChange}
              />
              <label>Администратор:</label>
              <select
                name="isadmin"
                value={editedUser.isadmin}
                onChange={handleInputChange}
              >
                <option value={0}>Нет</option>
                <option value={1}>Да</option>
              </select>
              <label>Статус активности:</label>
              <select
                name="enabled"
                value={editedUser.enabled}
                onChange={handleInputChange}
              >
                <option value={1}>Активен</option>
                <option value={0}>Неактивен</option>
              </select>
              <button type="button" onClick={handleEditSave}>
                Сохранить
              </button>
            </form>
          </div>
        </div>
      )}
      {selectedForAddUser && (
        <div className="edit_user_wrap" onClick={handeleWrapClick}>
          <div ref={modalRef} className="edit_user__modal">
            <span className="close" onClick={handleOnCancel}>
              &times;
            </span>
            <h2>Добавить пользователя</h2>
            <form>
              <label>ФИО:</label>
              <input
                type="text"
                name="fullname"
                value={addUser.fullname}
                onChange={handleInputAddChange}
              />
              <label>Логин:</label>
              <input
                type="text"
                name="login"
                value={addUser.login}
                onChange={handleInputAddChange}
              />
              <label>Пароль:</label>
              <input
                type="password"
                name="password"
                value={addUser.password}
                onChange={handleInputAddChange}
              />
              <label>Администратор:</label>
              <select
                name="isadmin"
                value={addUser.isadmin}
                onChange={handleInputAddChange}
              >
                <option value={0}>Нет</option>
                <option value={1}>Да</option>
              </select>
              <button type="button" onClick={handleAddSave}>
                Сохранить
              </button>
            </form>
          </div>
        </div>
      )}
      {selectedForAccess && (
        <div className="edit_user_wrap" onClick={handeleWrapClick}>
          <div ref={modalRef} className="access_list">
            <div className="access__header">
              <span>
                {" "}
                Права пользователя: <strong>{accessUser.fullname}</strong>
              </span>
              <div className="add__new_role" onClick={openNewModal}>
                Добавить
              </div>
            </div>
            <span className="close" onClick={handleOnCancel}>
              &times;
            </span>
            <table>
              <thead>
                <tr>
                  <th>Район</th>
                  <th>Роль</th>
                  <th>Действие</th>
                </tr>
              </thead>
              <tbody>
                {accessListOfUser.map((item) => (
                  <tr key={item.id}>
                    <td>{deps.find((dep) => dep.id === item.dep_id)?.name}</td>
                    <td>
                      {roles.find((role) => role.id === item.role_id)?.name}
                    </td>
                    <td
                      className="delete__option"
                      onClick={() => {
                        handelDeleteRole(item);
                      }}
                    >
                      Удалить
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {isOpenNewModal && (
        <div className="add__new__role__modal">
          <div className="role__block">
            Район:
            <select value={selectedDepValue} onChange={handelChangeSelectDep}>
              {depsForAdd.map((item) => (
                <option value={item.id}>{item.name}</option>
              ))}
            </select>
          </div>
          <div className="role__block">
            Роль:
            <select value={selectedRoleValue} onChange={handelChangeSelectRole}>
              {roles.map((item) => (
                <option value={item.id}>{item.name}</option>
              ))}
            </select>
          </div>
          <div className="btn__add__role add__buttons" onClick={handeleAddRole}>
            Добавить роль для пользователя
          </div>
          <span className="close" onClick={handleOnCloseRole}>
            &times;
          </span>
        </div>
      )}
    </>
  );
}

export { UserPage};
